/** ID do elemento <style> injetado no <head> */
const STYLE_ELEMENT_ID = 'partner-fonts';

/**
 * @typedef {Object} PartnerFont
 * @property {string} family - Nome da familia de fonte (ex.: "BancoDoBrasilTextos")
 * @property {number} weight - Peso da fonte (ex.: 400, 700)
 * @property {"normal"|"italic"} style - Estilo da fonte
 * @property {string} src - URL ou caminho do arquivo de fonte (formato url())
 */

/**
 * Gera uma regra @font-face CSS a partir de um objeto PartnerFont.
 *
 * Todas as regras incluem font-display: swap para evitar bloqueio de
 * renderizacao durante o carregamento da fonte.
 *
 * @param {PartnerFont} font - Objeto com dados da fonte
 * @returns {string} Regra @font-face formatada
 */
const buildFontFaceRule = (font) => `@font-face {
  font-family: "${font.family}";
  font-weight: ${font.weight};
  font-style: ${font.style};
  font-display: swap;
  src: ${font.src};
}`;

/**
 * Injeta fontes do parceiro ativo no <head> via elemento <style>.
 *
 * Cria ou substitui o elemento <style id="partner-fonts"> contendo regras
 * @font-face para cada fonte do array fornecido. Se o elemento ja existe
 * (troca de parceiro), remove o anterior antes de injetar o novo.
 *
 * @param {PartnerFont[]} fonts - Array de fontes do parceiro ativo
 */
export const injectPartnerFonts = (fonts) => {
    // Remover elemento anterior (troca de parceiro)
    const existingStyle = document.getElementById(STYLE_ELEMENT_ID);
    if (existingStyle) {
        existingStyle.remove();
    }

    // Se nao ha fontes para injetar, apenas limpar
    if (!fonts || fonts.length === 0) {
        return;
    }

    // Gerar regras @font-face para cada fonte
    const cssRules = fonts.map(buildFontFaceRule).join('\n\n');

    // Criar e inserir elemento <style> no <head>
    const styleElement = document.createElement('style');
    styleElement.id = STYLE_ELEMENT_ID;
    styleElement.textContent = cssRules;

    document.head.appendChild(styleElement);
};
